var defaults = {
  //url: '//res.wx.qq.com/open/js/jweixin-1.0.0.js', // 微信JSSDK的URL
  url: '//s0.meituan.net/bs/delivr/0315c86:jsm/lib/weixin/jweixin-1.1.0.js', // 微信JSSDK的URL,由于CSP原因，使用meituan.net域下
  configHostnameMap: [ // 配置wx的js与域名的映射关系
    { pattern: /dianping.com$/, host: 'cps.dianping.com' },
    { pattern: /51ping.com$/, host: 'tcps.51ping.com' },
    { pattern: /.meituan.com|m.maoyan.com$/, host: 'i.meituan.com/firework/api'}
  ],
  config: { // 默认配置
    debug: false
  },
  onError: function (msg) {
    console && console.error && console.error(msg);
  }
};

var states = ['not-auth', 'being-auth', 'auth-success', 'auth-fail']

if (!window._MTDPAuth_) {
  window._MTDPAuth_ = {
    state: states[0],
    callbackQueue: []
  }
}


var callbackQueue = window._MTDPAuth_.callbackQueue;
var loadScript = function (src, onload) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = onload;
  document.getElementsByTagName('head')[0].appendChild(script);
};
var apis = [
  'checkJsApi', 

  'onMenuShareTimeline', 
  'onMenuShareAppMessage', 
  'onMenuShareQQ', 
  'onMenuShareWeibo',
  'onMenuShareQZone',

  'startRecord',
  'stopRecord',
  'onVoiceRecordEnd',
  'playVoice',
  'pauseVoice',
  'stopVoice',
  'onVoicePlayEnd',
  'uploadVoice',
  'downloadVoice',

  'chooseImage',
  'previewImage',
  'uploadImage',
  'downloadImage',

  'translateVoice',
  'getNetworkType',
  'openLocation',
  'getLocation',
  'hideOptionMenu',
  'showOptionMenu',
  'hideMenuItems',
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem',
  'closeWindow',
  'scanQRCode',
  'chooseWXPay',
  'openProductSpecificView',
  'addCard',
  'chooseCard',
  'openCard'
];

function ready(callback) {
  if (window._MTDPAuth_.state === states[2] || window._MTDPAuth_.state === states[3]) {
    return callback();
  }

  var options = defaults;
  // 如果querystring中包含debug:wx字段，说明要开启debug模式
  if (/[\?&]debug:wx($|&)/.test(window.location.search)) options.config.debug = true;

  callbackQueue.push(callback);

  if (window._MTDPAuth_.state === states[1]) return;

  window._MTDPAuth_.state === states[1];

  var authHost = function() {
    var list = options.configHostnameMap;
    for (var i = 0; i < list.length; i++) {
      if (list[i].pattern.test(location.hostname)) return list[i].host;
    }
    return list[0].host;
  }();
  var useMeituanAuth = authHost.indexOf('i.meituan.com') > -1;

  var configSearch = "?apis=" + (apis.join(',')) + "&" +
    Object.keys(options.config).map(function (name) { return ((encodeURIComponent(name)) + "=" + (encodeURIComponent(options.config[name]))); }).join('&');

  function goAuth() {
    var doCallback = function () {
      window.wx.error(function(e) {
        window._MTDPAuth_.state = states[3];
        window.__KNB_ON_WX_ERROR && window.__KNB_ON_WX_ERROR(e);
      });
      window.wx.ready(function () {
        window._MTDPAuth_.state = states[2];
        while(callbackQueue && callbackQueue.length) {
          var cb = callbackQueue.shift();
          cb && cb();
        }
      });
    };

    if (useMeituanAuth) {
      window.jsonpWXLoader = function (res) {
        var config = {
          debug: options.config.debug,
          appId: 'wxc72f01f43da0083b',
          timestamp: res.data.timestamp,
          signature: res.data.signature,
          nonceStr: res.data.nonceStr,
          jsApiList: apis
        };
        window.wx.config(config);
        doCallback();
      };
      return loadScript('//' + authHost + '/weixin/config.json?url=' + encodeURIComponent(location.href) + '&callback=jsonpWXLoader');
    }
    loadScript('//' + authHost + '/weixin/config.js' + configSearch, doCallback);
  }

  if (window.wx) {
    goAuth();
  } else {
    loadScript(options.url, goAuth);
  }
}

module.exports = ready;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/wx/auth.js
// module id = 351
// module chunks = 0